module.exports = __webpack_public_path__ + "static/img/quick-order.72f551bd.jpg";